<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="设备编号：" prop="device_code">
                <span>{{model.device_code}}</span>
            </el-form-item>
            <el-form-item label="任务ID：" prop="code">
                <span>{{model.task_id}}</span>
            </el-form-item>
            <el-form-item label="功能编码：" prop="code">
                <span>{{model.code}}</span>
            </el-form-item>
            <el-form-item label="时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="报文内容：" prop="message">
                <span>{{model.message}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById } from '@/api/common'

export default {
    name: 'messageLogInfo',
    mixins: [editutil],
    props: {
        id1: {
            type: String,
            default() {
                return "";
            }
        },
    },
    data() {
        return {
            model: {
                code: '',
                device_code: '',
                add_time: '',
                message: '',
            },
            getObj:{
                url:'/api/admin/messagelog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {
        getModelData() {
            this.getObj.data.value = this.id1;
            getModelById(this.getObj).then(res => {
                if (res.code === 1) {
                    this.model = res.data;
                } else {
                    this.$msg(res.msg)
                    this.closeDialog()
                }
            })
        },
    }
};
</script>